import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AngularFirestore } from '@angular/fire/firestore';

import { Match, PublishedMatch } from '../../models';
import { BaseService } from './base-dataservice';
import { isArray } from 'util';
import { map } from 'rxjs/operators';

@Injectable()
export class MatchService extends BaseService<Match> {
  constructor(afs: AngularFirestore) {
    super('matches', afs);
  }

  // Static Methods
  public static createPublishedMatch(match: Match): PublishedMatch {
    let {
      competitionName,
      grade,
      venue,
      year
    } = match;

    const awayTeam = match.awayTeam;
    const homeTeam = match.homeTeam;
    const matchDate = match.matchDate;
    const name = match.name;
    const roundNumber = match.roundNumber;
    const events = match.events ? (isArray(match.events) ? [...match.events] : []) : [];
    const media = match.media;

    competitionName = competitionName ? competitionName : null;
    grade = grade ? grade : null;
    venue = venue ? venue : null;
    year = year ? year : null;

    const publishedMatch = {
      name,
      awayTeam,
      competitionName,
      grade,
      homeTeam,
      matchDate,
      roundNumber,
      venue,
      year,
      events,
      media,
      sourceMatchId: match.id
    } as PublishedMatch;

    return publishedMatch;
  }

  // Custom Methods

  getForUser(userId: string): Observable<Match[]> {
    console.info('[Match Service] getForUser: ', userId);
    const coll = this.afs.collection(this.uri, ref => ref.where('userId', '==', userId));

    return coll.snapshotChanges().pipe(
      map(changes => {
        return changes.map(a => {
          const data = a.payload.doc.data() as Match;
          data.id = a.payload.doc.id;
          return data;
        })
      })
    );
  }


}
